module.exports = __webpack_public_path__ + "img/stand_linche_cut.d1fb01b8.png";